export const extractDate = (date: string) => {
	const [, day, month, year] = /(\d{2})-?(\d{2})-?(\d{4})/.exec(date)!

	return new Date(`${year}-${month}-${day}`)
}
